import React, { useEffect } from "react";
import "./ourSolutions.css";

import Meta from "utils/meta";

const OurSolutions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Meta title="Our Solutions | The Realtor Desk" description="" />
      <div className="ourSolutions-container">
        <div className="ourSolutions-heading">
          <h1>How is CRM important for realtors? </h1>
        </div>
        <div className="crm-Description">
          <p>
            Real estate is all about building trust, and it's no surprise that
            82% of new property sales are referrals from either existing
            contacts, previous clients, family, friends, or relatives. Moreover,
            when it comes to real estate businesses, selling or buying is a long
            process, with many follow-ups and re-negotiations. In such
            scenarios, implementing a real estate CRM software gives realtors an
            efficient way to manage contacts, schedule tasks, monitor their
            pipelines, and stay organized to build successful relationships and
            close deals.
          </p>
        </div>
        <div className="ourSolutions-description">
          <div className="ourSolutions-Omnichannel">
            <h1>Omnichannel Communication :-</h1>
            <p>
              With the Omnichannel Communication feature, you can collect
              inquiries from multiple channels. Customers have more ways to
              interact with businesses than ever before. Realtor CRM allows you
              to connect with your customers through multiple channels, all
              while centralizing information that empowers your sales team to
              have contextual, meaningful conversations with your prospects.
            </p>
            <div className="Omnichannel-list">
              <h2>List of Omnichannel Communication</h2>
              <p>1:- Email</p>
              <p>2:- Telephony</p>
              <p>3:- Social Media</p>
              <p>4:- SMS</p>
              <p>5:- Live Chat</p>
              <p>6:- WhatsApp</p>
              <p>7:- Web forms</p>
              <p>8:- Self-Service Portals</p>
              <p>9:- Web Conferencing</p>
              <p>10:- Communication Context </p>
              <p>11:- Team Collaboration</p>
              <p>12:- Realtime Notifications</p>
            </div>
          </div>
          <div className="ourSolutions-campaigns">
            <h1>Built-in Campaigns :-</h1>
            <p>
              This feature helps you to send out drip email campaigns. Drip
              email is simply sending a limited number of emails to your
              audience automatically, on a set timing, based on actions they
              take or changes in their status. Businesses use drip email to keep
              in touch with an audience—in a personalized and targeted
              way—following important actions or dates.{" "}
            </p>
            <div className="campaigns-list">
              <h2>How to set up a drip campaign</h2>
              <p>1:- Choose your trigger</p>
              <p>2:- Identify your audience</p>
              <p>3:- raft your message for each email</p>
              <p>4:- Measure and adjust based on performance</p>
              <p>5:- Maintain your drip emails</p>
            </div>
          </div>
          <div className="ourSolutions-project-management">
            <h1>Project Management :-</h1>
            <p>
              Access your CRM data on-the-go with fully-featured mobile
              applications for iOS and Android. Tools to keep tabs on all your
              ongoing projects, any product, app, or service is only as good as
              your audience’s perception of it. As your marketing team strives
              to reach more of your target customers, The Realtor Desk Projects
              can help make the process both easier and more fun.
            </p>
            <div className="campaigns-list">
              <h2>
                Why is The Realtor Desk Projects the best project management
                tool?
              </h2>
              <p>1:- Save time, set recurrences</p>
              <p>2:- Automate to get there fast</p>
              <p>3:- Gantt charts</p>
              <p>4:- Collaborate.</p>
            </div>
          </div>
          <div className="ourSolutions-third-party">
            <h1>Third-Party integrations :-</h1>
            <p>
              Gain insights into your sales performance with comprehensive
              analytics and reporting tools. Integrating third-party APIs into
              one's application is a strategic move to elevate your company's
              capabilities and operational efficiency. Using APIs to deliver
              better value at a lower cost and without over-investing in
              development allows your application to adapt and scale up much
              faster.
            </p>
            <div className="third-party-list">
              <h2>How to effectively integrate third-party APIs</h2>
              <p>1:- Research API documentation</p>
              <p>2:- Plan the integration design</p>
              <p>3:- Implement robust security measures</p>
              <p>
                4:- Leverage technologies that simplify third-party integrations
              </p>
              <p>5:- Design integrations with scalability in mind</p>
              <p>6:- Develop error-handling mechanisms</p>
              <p>7:- Make sure your APIs well tested</p>
              <p>8:- Thoroughly choose your APIs</p>
            </div>
          </div>
          <div className="ourSolutions-customization">
            <h1>Complete Customization :-</h1>
            <p>
              Complete customization to accommodate the unique processes of real
              estate agents. Manage your customer relationships effectively with
              centralized customer data and interaction history.
            </p>
            <div className="customization-list">
              <h2>To customize Real Estate's unique requirements</h2>
              <p>1:- Create a custom module called Property</p>
              <p>
                2:- Create multiple layouts within the Property module to manage
                different housing types like Residential Property and Commercial
                Property
              </p>
              <p>
                3:- Set layout rules to create conditional layouts in the
                Property module for defining field dependency
              </p>
              <p>
                4:- Add multiple line items in the layouts by including sub
                forms
              </p>
              <p>5:- Ensure data accuracy by setting up validating rules</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurSolutions;
